module.exports = __webpack_public_path__ + "img/santaana500.74803363.jpg";